import { getArea, getLength } from "ol/sphere";
// Математика расчетов вывода длины
export function formatLength(line: any) {
    const length = getLength(line);
    let output;
    if (length > 100) {
        output = Math.round((length / 1000) * 100) / 100 + ' км';
    } else {
        output = Math.round(length * 100) / 100 + ' м';
    }
    return output;
};
// Математика расчетов вывода площади
export function formatArea(polygon: any) {
    const area = getArea(polygon);
    let output;
    if (area > 10000) {
        output = Math.round((area / 1000000) * 100) / 100 + ' км\xB2';
    } else {
        output = Math.round(area * 100) / 100 + ' м\xB2';
    }
    return output;
};